module.exports = __webpack_public_path__ + "images/emoji/alien.c3f553b2608bf5cf39b5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/alien.png
// module id = DrOe
// module chunks = 2